import { TranslationKey } from '@hermes/translations'
import { CurrencySymbol, DefaultCurrency, getCurrencyFromLocale } from '@lib/utils/getCurrencyFromLocale'
import { useIntl, MessageDescriptor as IntlMessageDescriptor } from 'react-intl'

const formatNumber = (value: number, currency: DefaultCurrency) => {
  if (currency === DefaultCurrency.NO) {
    return `${CurrencySymbol[currency]} ${value}`
  }
  if (currency === DefaultCurrency.SE) {
    return `${value} ${CurrencySymbol[currency]}`
  }
  return `${value} ${currency}`
}

type MessageDescriptor = { id: TranslationKey } & Omit<IntlMessageDescriptor, 'id'>

export default function useTranslateMessage() {
  const intl = useIntl()
  const { locale } = intl
  const localCurrency = getCurrencyFromLocale(locale)

  return {
    t: (descriptor: MessageDescriptor, values?: Record<string, any>) => intl.formatMessage(descriptor, values),
    n: (value: number) => formatNumber(value, localCurrency),
    d: intl.formatDate
  }
}
